// import React, { useState } from "react";
// import { fetchBatch, buySubscription, fetchPackages, getPlansByPackageId, getPlans } from "../../lib/Subscription";
// import { getClasses } from "../../lib/ClassApi";
// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { getSubjectsByclassId, getCoursesByclassId } from "../../lib/ClassApi";
// import Logo from "../../components/common/Logo";


// const SubscriptionPage = () => {
//   const navigate = useNavigate();

//   const [classList, setClassList] = useState([]);
//   const [subjectsList, setSubjectsList] = useState([]);
//   // const [batchList, setBatchList] = useState([]);
//   const [courseBatchList, setCourseBatchList] = useState([]);

//   //
//   const [courseList, setCourseList] = useState([]);
//   // const [packageList, setPackageList] = useState([]);
//   const [planList, setPlanList] = useState([]);
//   //

//   const [userData, setUserData] = useState(null);

//   //get userProfile===============
//   useEffect(() => {

//     const storedUser = JSON.parse(localStorage.getItem("user")) || [];

//     if (storedUser) {
//       setUserData(storedUser);

//       // auto fill current class
//       setForm((prev) => ({
//         ...prev,
//         classId: storedUser.classId || ""
//       }));
//     }
//   }, []);

//   //===========course Amount ==========
//   // const getAmount = () => {
//   //   switch (form.plan) {
//   //     case "full": return 24000;
//   //     case "halfyearly": return 12000;
//   //     case "quarterly": return 7200;
//   //     case "monthly": return 2400;
//   //     default: return 0;
//   //   }
//   // };

//   const [form, setForm] = useState({
//     classId: '',

//     type: "New",

//     courseIds: [],

//     //batchId: "",
//     selectedBatches: [],

//     // packageId: "",

//     planId: "",

//     amount: 0,

//     paymentMethod: "UPI",
//   });

//   const handleChange = (field, value) => {

//     if (field === "classId") {

//       setForm({
//         ...form,

//         classId: value,

//         courseIds: [],

//         // batchId: "",
//         selectedBatches: [],

//         packageId: "",

//         planId: "",

//         amount: 0
//       });
//       setCourseBatchList([]);
//       //setBatchList([]);
//       //setPackageList([]);
//       setPlanList([]);

//       return;
//     }

//     if (field === "batchId") {

//       setForm({
//         ...form,

//         batchId: value,

//         packageId: "",

//         planId: "",

//         amount: 0
//       });

//       //setPackageList([]);
//       setPlanList([]);

//       return;
//     }

//     if (field === "packageId") {

//       setForm({
//         ...form,

//         packageId: value,

//         planId: "",

//         amount: 0
//       });

//       setPlanList([]);

//       return;
//     }
//     setForm({
//       ...form,
//       [field]: value
//     });
//   };

//   //=========== Fetch class list===========
//   const handleCheckbox = (field, value) => {

//     const exists = form[field].includes(value);

//     const updatedValues = exists
//       ? form[field].filter((v) => v !== value)
//       : [...form[field], value];

//     setForm({
//       ...form,

//       [field]: updatedValues,

//       // batchId: "",
//       selectedBatches: [],

//       packageId: "",

//       planId: "",

//       amount: 0
//     });

//     setCourseBatchList([]);
//     //setBatchList([]);
//     //setPackageList([]);
//     setPlanList([]);
//   };

//   useEffect(() => {
//     const fetchClasses = async () => {
//       const res = await getClasses(-1);
//       if (res.success) setClassList(res.data);
//     };
//     fetchClasses();
//   }, []);
//   //==============Fetch Subject list=============


//   //=============Fetch Course list==========
//   const fetchCourses = async (classId) => {
//     try {
//       const res = await getCoursesByclassId(classId);

//       if (res.success) {
//         setCourseList(res.data);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     if (form.classId) {
//       fetchCourses(form.classId);
//     }
//   }, [form.classId]);

//   //==========Fetch  Batch==========
//   // useEffect(() => {
//   //   if (form.classId && form.subjects.length > 0) {
//   //     fetchBatches(form.classId, form.subjects[0]);
//   //   }
//   // }, [form.classId, form.subjects]);

//   useEffect(() => {
//     if (
//       //form.classId &&
//       form.courseIds.length > 0
//     ) {
//       fetchBatches();
//     }
//   }, [form.classId, form.courseIds]);


//   // const fetchBatches = async (classId, subjectId) => {
//   //   try {
//   //     const res = await fetchBatch(classId, subjectId);

//   //     if (res.success) {
//   //       setBatchList(res.data); // HERE ONLY
//   //     }
//   //   } catch (err) {
//   //     console.error("Batch API Error:", err);
//   //   }
//   // };



//   //==============Handle subscription===================

//   // const fetchBatches = async () => {
//   //   try {

//   //     const payload = {
//   //       classId: Number(form.classId),

//   //       courseIds: form.courseIds
//   //     };

//   //     console.log("BATCH PAYLOAD:", payload);

//   //     const res = await fetchBatch(payload);

//   //     console.log("BATCH RESPONSE:", res);

//   //     // if (res.success) {
//   //     //   setBatchList(res.data);
//   //     // }
//   //     if (res.success) {
//   //       setCourseBatchList(res.data);
//   //     }

//   //   } catch (err) {
//   //     console.error("Batch API Error:", err);
//   //   }
//   // };

//   const fetchBatches = async () => {
//     try {
//       const payload = {
//         classId: Number(form.classId),
//         courseIds: form.courseIds
//       };

//       const res = await fetchBatch(payload);

//       if (res.success) {

//         const groupedCourses = form.courseIds.map(courseId => {

//           const courseInfo = courseList.find(
//             c => c.courseId === courseId
//           );

//           return {
//             courseId,
//             courseName: courseInfo?.courseName || `Course ${courseId}`,
//             batches: res.data.filter(
//               b => b.courseId === courseId
//             )
//           };
//         });

//         setCourseBatchList(groupedCourses);
//       }

//     } catch (err) {
//       console.error(err);
//     }
//   };

//   //=============Handle selected Batches ===============
//   const handleBatchSelection = (
//     courseId,
//     batchId
//   ) => {
//     setForm((prev) => {
//       const remaining =
//         prev.selectedBatches.filter(
//           (x) => x.courseId !== courseId
//         );

//       return {
//         ...prev,
//         selectedBatches: [
//           ...remaining,
//           {
//             courseId,
//             batchId: Number(batchId),
//           },
//         ],
//       };
//     });
//   };

//   //=============fetch packages==============


//   useEffect(() => {

//     if (
//       form.selectedBatches.length ===
//       form.courseIds.length &&
//       form.courseIds.length > 0
//     ) {
//       fetchPlans();
//     }

//   }, [
//     form.selectedBatches,
//     form.courseIds
//   ]);

//   const fetchPlans = async () => {

//     try {

//       const payload = {
//         courseIds: form.courseIds
//       };

//       const res = await getPlans(payload);

//       console.log("PLAN RESPONSE", res);

//       if (res.success) {

//         setPlanList(res.plans);
//       }

//     } catch (error) {

//       console.error(error);
//     }
//   }
//   //====================Paybutton handler ======================

//   const handlePay = async () => {
//     try {
//       const user = JSON.parse(localStorage.getItem("user") || "{}");

//       //  Validation
//       if (!form.classId) return alert("Select class");
//       //if (form.subjects.length === 0) return alert("Select subjects");
//       //if (!form.batchId) return alert("Select batch");
//       // if (!form.packageId)
//       //   return alert("Select package");
//       if (
//         form.selectedBatches.length !==
//         form.courseIds.length
//       ) {
//         return alert("Please select batch for all courses");
//       }
//       if (!form.planId)
//         return alert("Select plan");
//       console.log("=======UserId======= :", user.uuid);
//       const payload = {
//         userId: user.uuid,
//         classId: Number(form.classId),
//         //batchId: Number(form.selectedBatches),
//         selectedBatches: form.selectedBatches,
//         packageId: Number(form.packageId),

//         courseIds: form.courseIds,

//         planId: Number(form.planId),

//         amount: Number(form.amount),
//         // planId: form.plan === "full" ? 1 :
//         //   form.plan === "halfyearly" ? 2 :
//         //     form.plan === "quarterly" ? 3 : 4,

//         // subjectIds: form.subjects,

//         // planType: form.plan,
//         // amount:0,

//         paymentStatus: "SUCCESS",
//         paymentMode: form.paymentMethod,

//         paymentId: "pay_test_123",
//         razorpayOrderId: "order_test_123"
//       };

//       console.log("FINAL PAYLOAD:", payload);

//       const res = await buySubscription(payload);
//       if (res.success) {
//         alert("Subscription Created Successfully");
//         navigate("/live-classes");
//       }

//       // if (res.success) {
//       //   alert("Subscription Created Successfully ");
//       // } else {
//       //   alert(res.message || "Subscription failed ");
//       // }

//     } catch (err) {
//       console.error("FULL ERROR:", err);

//       if (err.response) {
//         console.error("API ERROR:", err.response.data);
//         alert(err.response.data?.message || "API Error ");
//       } else {
//         alert("Server not reachable ");
//       }
//     }
//   };

//   //====================DateTime formatter helper===========
//   const formatTime = (timeObj) => {
//     if (!timeObj?.hasValue) return "";

//     const hours = timeObj.value.hours;
//     const minutes = timeObj.value.minutes;

//     const period = hours >= 12 ? "PM" : "AM";

//     const formattedHour =
//       hours % 12 || 12;

//     return `${formattedHour}:${minutes
//       .toString()
//       .padStart(2, "0")} ${period}`;
//   };

//   return (
//     <>
//       <div className=" bg-secondary flex flex-col items-start px-4 py-6 md:px-10">
//         {/* Logo */}
//         <div className="text-center mb-8 ">

//           <Logo />

//         </div>

//       </div>


//       <div className="min-h-screen bg-secondary flex flex-col items-center">
//         {/* TITLE */}
//         <h1 className="text-center font-semibold text-black mb-6">
//           Buy / Renew Subscription
//         </h1>

//         {/* MAIN */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto">

//           {/* LEFT */}
//           <div className="w-full max-w-[320px] flex flex-col gap-4">

//             {/* Top Banner */}
//             <div className="bg-primary text-white rounded-md px-5 flex items-center h-[90px]">
//               <p className="font-semibold text-[22px]">
//                 @ INR 1200 / subject / month*
//               </p>
//             </div>

//             {/* Card 1 */}
//             <div className="bg-primary text-white rounded-md p-5 h-[130px] flex flex-col justify-center">
//               <p className="font-semibold text-[27px]">Fee for Class 6-10</p>
//               <p className="font-semibold">INR 24,000 per year*</p>
//               <p className="text-xs mt-2">Math & Science</p>
//             </div>

//             {/* Card 2 */}
//             <div className="bg-primary text-white rounded-md p-5 h-[130px] flex flex-col justify-center">
//               <p className="font-semibold text-[27px]">Fee for Class 11-12</p>
//               <p className="font-semibold">INR 36,000 per year*</p>
//               <p className="text-xs mt-2">Math / Bio / Che / Phy</p>
//             </div>



//             <p className="text-[15px] mt-4">
//               *on full one-time fee payment plan. 2 months discount applied.
//               Applicable fee for other payment plans @ Rs 2400 per month
//             </p>
//           </div>

//           {/* RIGHT */}
//           <div className="relative pl-6 border-l border-gray-400 text-sm">

//             <h1 className="font-semibold text-black mb-6 ">
//               Hi, you are subscribing to InstaED.{" "}
//               {/* <span className="float-right">
//                 <b>Current:</b> {userData?.className || "-"}
//               </span> */}
//             </h1>

//             {/* Class */}
//             <div className="mb-3">
//               <span className="font-medium text-primary font-semibold">
//                 Class you’re subscribing/ renewing to:
//               </span>{" "}
//               <select
//                 value={form.classId}
//                 onChange={(e) => handleChange("classId", e.target.value)}
//               >
//                 <option value="">Select Class</option>

//                 {classList.map((cls) => (
//                   <option key={cls.id} value={cls.id}>
//                     {cls.classname}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Subscription Type */}
//             <div className="mb-3 flex items-center gap-4">
//               <span className="font-medium text-primary font-semibold">Subscription type:</span>

//               <label className="flex items-center gap-1">
//                 <input
//                   type="checkbox"
//                   checked={form.type === "renewal"}
//                   onChange={() => handleChange("type", "renewal")}
//                 />
//                 Renewal
//               </label>

//               <label className="flex items-center gap-1">
//                 <input
//                   type="checkbox"
//                   checked={form.type === "new"}
//                   onChange={() => handleChange("type", "new")}
//                 />
//                 New
//               </label>
//             </div>

//             {/* Subjects */}
//             {/* <div className="mb-3 flex items-center flex-wrap gap-3">
//               <span className="font-medium">Select subjects:</span>

//               {["Math", "Science", "Bio", "Phy", "Che"].map((sub) => (
//                 <label key={sub} className="flex items-center gap-1">
//                   <input
//                     type="checkbox"
//                     checked={form.subjects.includes(sub)}
//                     onChange={() => handleCheckbox("subjects", sub)}
//                   />
//                   {sub}
//                 </label>
//               ))}
//             </div> */}
//             {/* <div className="mb-3 flex items-center flex-wrap gap-3">
//               <span className="font-medium text-primary font-semibold">Select subjects:</span>

//               {subjectsList.map((sub) => (
//                 <label key={sub.subjectId} className="flex items-center gap-1">
//                   <input
//                     type="checkbox"
//                     checked={form.subjects.includes(sub.subjectId)}
//                     onChange={() => handleCheckbox("subjects", sub.subjectId)}
//                   />
//                   {sub.subjectName}
//                 </label>
//               ))}
//             </div> */}

//             {/*Course List*/}

//             <div className="mb-3 flex items-center flex-wrap gap-3">
//               <span className="font-medium text-primary font-semibold">
//                 Select Courses:
//               </span>

//               {courseList.map((course) => (
//                 <label
//                   key={course.courseId}
//                   className="flex items-center gap-1"
//                 >
//                   <input
//                     type="checkbox"
//                     checked={form.courseIds.includes(course.courseId)}
//                     onChange={() =>
//                       handleCheckbox("courseIds", course.courseId)
//                     }
//                   />

//                   {course.courseName}
//                 </label>
//               ))}
//             </div>

//             {/* Academic */}
//             <div className="mb-3">
//               <span className="font-medium text-primary font-semibold">Academic session:</span>{" "}
//               Apr 2026–Mar 2027
//             </div>

//             {/* Weekdays */}
//             <span className="font-medium text-primary">Select Batch:</span>

//             {/*GetBatch */}

//             {/* <select
//               className="border p-2 rounded"
//               value={form.batchId}
//               onChange={(e) => handleChange("batchId", e.target.value)}
//             >
//               <option>Select Batch</option>
//               {batchList.map((b) => (
//                 <option key={b.batchId} value={b.batchId}>
//                   {b.batchtype} {formatTime(b.startTime)} - {formatTime(b.endTime)}
//                 </option>
//               ))}
//             </select> */}

//             {/* <select
//               className="border p-2 rounded w-full"
//               value={form.batchId}
//               onChange={(e) =>
//                 handleChange("batchId", e.target.value)
//               }
//             >
//               <option value="">
//                 Select Batch
//               </option>

//               {batchList.map((b) => (
//                 <option
//                   key={b.batchId}
//                   value={b.batchId}
//                 >
//                   {b.batchName} (
//                   {formatTime(b.startTime)}
//                   {" - "}
//                   {formatTime(b.endTime)})
//                 </option>
//               ))}
//             </select> */}

//             {courseBatchList.map((course) => (

//               <div key={course.courseId}>

//                 <label className="font-semibold">
//                   {course.courseName}
//                 </label>

//                 <select
//                   className="border p-2 rounded w-full mt-1"
//                   value={
//                     form.selectedBatches.find(
//                       x => x.courseId === course.courseId
//                     )?.batchId || ""
//                   }
//                   onChange={(e) =>
//                     handleBatchSelection(
//                       course.courseId,
//                       e.target.value
//                     )
//                   }
//                 >
//                   <option value="">
//                     Select Batch
//                   </option>

//                   {course.batches.map((batch) => (

//                     <option
//                       key={batch.batchId}
//                       value={batch.batchId}
//                     >
//                       {batch.batchName}
//                       {" ("}
//                       {formatTime(batch.startTime)}
//                       {" - "}
//                       {formatTime(batch.endTime)}
//                       {")"}
//                     </option>

//                   ))}
//                 </select>

//               </div>

//             ))}

//             {/*Get Packages */}
//             {/* <div className="mt-4">

//               <span className="font-medium text-primary font-semibold">
//                 Available Packages:
//               </span>

//               <div className="flex flex-col gap-3 mt-2">

//                 {packageList.map((pkg) => (

//                   <label
//                     key={pkg.packageId}
//                     className="border rounded p-3 flex items-start gap-2"
//                   >

//                     <input
//                       type="radio"
//                       name="packageId"
//                       checked={
//                         Number(form.packageId) ===
//                         pkg.packageId
//                       }
//                       onChange={() =>
//                         handleChange(
//                           "packageId",
//                           pkg.packageId
//                         )
//                       }
//                     />

//                     <div>

//                       <p className="font-semibold">
//                         {pkg.packageName}
//                       </p>

//                       <p className="text-sm text-gray-500">
//                         {pkg.description}
//                       </p>

//                     </div>

//                   </label>

//                 ))}

//               </div>

//             </div> */}

//             <div className="mb-4">

//               <p className="font-medium mb-2 text-primary font-semibold">
//                 Select Plan
//               </p>

//               <div className="space-y-3">

//                 {planList.map((plan) => (

//                   <label
//                     key={plan.planId}
//                     className="flex items-start gap-3 border rounded p-3"
//                   >

//                     <input
//                       type="radio"
//                       name="plan"
//                       checked={
//                         Number(form.planId) === plan.planId
//                       }
//                       onChange={() => {

//                         setForm(prev => ({
//                           ...prev,
//                           planId: plan.planId,
//                           amount: plan.finalAmount
//                         }));
//                       }}
//                     />

//                     <div>

//                       <p className="font-semibold">
//                         {plan.planName}
//                       </p>

//                       <p className="text-sm text-gray-500">
//                         Duration :
//                         {" "}
//                         {plan.durationDays}
//                         {" "}
//                         Days
//                       </p>

//                       <p className="text-sm">
//                         Course Total :
//                         {" "}
//                         ₹{plan.courseTotal}
//                       </p>

//                       <p className="text-sm">
//                         Gross Amount :
//                         {" "}
//                         ₹{plan.grossAmount}
//                       </p>

//                       <p className="text-sm text-green-600">
//                         Discount :
//                         {" "}
//                         {plan.discountPercent}%
//                       </p>

//                       <p className="font-bold text-lg">
//                         ₹{plan.finalAmount}
//                       </p>

//                     </div>

//                   </label>

//                 ))}

//               </div>

//             </div>




//             {/* Payment Plan */}
//             {/* <div className="mb-4">
//               <p className="font-medium mb-2 text-primary font-semibold">
//                 Select the payment plan:
//               </p>

//               <div className="space-y-2">
//                 <label className="flex items-center gap-2">
//                   <input
//                     type="radio"
//                     name="plan"
//                     checked={form.plan === "full"}
//                     onChange={() => handleChange("plan", "full")}
//                   />
//                   Full/ One-time (Rs 24,000)
//                   <span className="line-through text-xs ml-2">
//                     28,800
//                   </span>
//                   <span className="text-xs ml-2">
//                     Discount: Rs 4800 (2 months)
//                   </span>
//                 </label>

//                 <label className="flex items-center gap-2">
//                   <input
//                     type="radio"
//                     name="plan"
//                     checked={form.plan === "halfyearly"}
//                     onChange={() => handleChange("plan", "halfyearly")}
//                   />
//                   Half-Yearly (Rs 12,000)
//                 </label>

//                 <label className="flex items-center gap-2">
//                   <input
//                     type="radio"
//                     name="plan"
//                     checked={form.plan === "quarterly"}
//                     onChange={() => handleChange("plan", "quarterly")}
//                   />
//                   Quarterly (Rs 7,200)
//                 </label>

//                 <label className="flex items-center gap-2">
//                   <input
//                     type="radio"
//                     name="plan"
//                     checked={form.plan === "monthly"}
//                     onChange={() => handleChange("plan", "monthly")}
//                   />
//                   Monthly (Rs 2,400)
//                 </label>
//               </div>
//             </div> */}

//             <div className="mb-4">

//               <p className="font-medium mb-2 text-primary font-semibold">
//                 Select the payment plan:
//               </p>

//               <div className="space-y-3">

//                 {planList.map((plan) => (

//                   <label
//                     key={plan.id}
//                     className="flex items-start gap-3 border rounded p-3"
//                   >

//                     {/* <input
//                       type="radio"
//                       name="plan"
//                       checked={
//                         Number(form.planId) ===
//                         plan.planId
//                       }
//                       onChange={() => {
//                         setForm((prev) => ({
//                           ...prev,
//                           planId: plan.planId,
//                           amount: plan.discountPrice
//                         }));
//                       }}
//                     /> */}
//                     <input
//                       type="radio"
//                       name="plan"
//                       checked={
//                         Number(form.planId) === plan.planId
//                       }
//                       onChange={() => {
//                         setForm((prev) => ({
//                           ...prev,
//                           planId: plan.planId,
//                           amount: plan.discountPrice
//                         }));
//                       }}
//                     />

//                     <div>

//                       <p className="font-semibold">
//                         {plan.planName}
//                       </p>

//                       <p className="text-sm text-gray-500">
//                         Duration:
//                         {" "}
//                         {plan.durationDays}
//                         {" "}
//                         Days
//                       </p>

//                       <div className="flex gap-2 items-center">

//                         <span className="line-through text-gray-400">
//                           ₹{plan.actualPrice}
//                         </span>

//                         <span className="font-bold text-green-600">
//                           ₹{plan.discountPrice}
//                         </span>

//                       </div>

//                     </div>

//                   </label>

//                 ))}

//               </div>

//             </div>

//             {/* Payment Method */}
//             <div className="mb-4">
//               <p className="font-medium mb-2 text-primary font-semibold">
//                 How do you wish to pay?
//               </p>

//               {["Debit Card/ Credit Card", "Internet Banking", "UPI", "GPay/ Paytm"].map((method) => (
//                 <label key={method} className="flex items-center gap-2 mb-1">
//                   <input
//                     type="radio"
//                     name="paymentMethod"
//                     checked={form.paymentMethod === method}
//                     onChange={() => handleChange("paymentMethod", method)}
//                   />
//                   {method}
//                 </label>
//               ))}
//             </div>

//             {/* Button */}
//             <div className="flex items-center gap-4 bg-bS">
//               <button
//                 onClick={() => {
//                   console.log("BUTTON CLICKED");
//                   handlePay();
//                 }}
//                 className="bg-[#1e1e1e] text-white px-4 py-1 text-sm rounded"
//               >
//                 Pay
//               </button>
//               <span className="text-xs underline cursor-pointer">
//                 Refund policy
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* FOOTER */}
//         <div className="text-center text-xs mt-10 text-gray-600">
//           2026 | Edworks | Terms of Use | Privacy Policy
//         </div>
//       </div>
//     </>
//   );
// };

// export default SubscriptionPage;


import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  fetchBatch,
  buySubscription,
  getPlans,
} from "../../lib/Subscription";

import {
  getClasses,
  getCoursesByTagAndSchoolId,
} from "../../lib/ClassApi";
import Logo from "../../components/common/Logo";

const SubscriptionPage = () => {
  const navigate = useNavigate();

  /* =====================================================
     API STATES
  ===================================================== */

  const [classList, setClassList] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [courseBatchList, setCourseBatchList] = useState([]);
  const [planList, setPlanList] = useState([]);

  const [userData, setUserData] = useState(null);

  /* =====================================================
     CURRENT STUDENT STATE

     Current class is intentionally different from
     subscription target class.

     Example:
     Current Class = 7
     Academic Status = Expired
     Subscribe/Renew = Class 9
  ===================================================== */

  const [currentClassId] = useState(7);

  const [currentAcademicExpired] = useState(true);

  /* =====================================================
     SUBSCRIPTION STATES
  ===================================================== */

  // Target class for subscription.
  // Because current Class 7 academic session is expired,
  // we start with Class 9.
  const [selectedClassId, setSelectedClassId] =
    useState("9");

  const [subscriptionType, setSubscriptionType] =
    useState("New");

  const [weekday, setWeekday] =
    useState("Mon · Wed · Fri");

  const [selectedPlanId, setSelectedPlanId] =
    useState("");

  const [paymentMethod, setPaymentMethod] =
    useState("Debit or credit card");

  const [selectedCourseIds, setSelectedCourseIds] =
    useState([]);

  const [selectedBatches, setSelectedBatches] =
    useState([]);

  const [selectedPackageId, setSelectedPackageId] =
    useState("");

  const [selectedAmount, setSelectedAmount] =
    useState(24000);

  const [academicSession, setAcademicSession] = useState({
    startDate: "",
    endDate: "",
  });

  const getAcademicSessionDates = (response) => {
    const source = Array.isArray(response?.data)
      ? response.data[0]
      : response?.data || response;

    return {
      startDate:
        source?.startDate ??
        source?.StartDate ??
        source?.academicStartDate ??
        source?.academicSessionStartDate ??
        "",
      endDate:
        source?.endDate ??
        source?.EndDate ??
        source?.academicEndDate ??
        source?.academicSessionEndDate ??
        "",
    };
  };

  const formatAcademicDate = (date) => {
    if (!date) return "";

    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) return "";

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const academicSessionText = academicSession.startDate && academicSession.endDate
    ? `${formatAcademicDate(academicSession.startDate)} – ${formatAcademicDate(academicSession.endDate)}`
    : "Select class to load session";

  /* =====================================================
     CLASS FALLBACK
  ===================================================== */

  const defaultClasses = [
    {
      id: 6,
      className: "Class 6",
    },
    {
      id: 7,
      className: "Class 7",
    },
    {
      id: 8,
      className: "Class 8",
    },
    {
      id: 9,
      className: "Class 9",
    },
    {
      id: 10,
      className: "Class 10",
    },
  ];

  /* =====================================================
     USER DATA
  ===================================================== */

  useEffect(() => {
    try {
      const user = JSON.parse(
        localStorage.getItem("user") || "{}"
      );

      setUserData(user);

      /*
       * IMPORTANT:
       *
       * Do NOT overwrite selectedClassId here.
       *
       * Current student class can be 7,
       * but target subscription class is 9.
       */
    } catch (error) {
      console.error(
        "User data error:",
        error
      );
    }
  }, []);

  /* =====================================================
     GET CLASS LIST
     API UNCHANGED
  ===================================================== */

  useEffect(() => {
    const loadClasses = async () => {
      try {
        const storedUser = JSON.parse(
          localStorage.getItem("user") || "{}"
        );

        const schoolId =
          storedUser?.SchoolId ||
          storedUser?.schoolId ||
          storedUser?.SchoolID ||
          localStorage.getItem("schoolId");

        // TAGTypes/1 returns classes assigned to the selected school.
        const response = await getClasses(1, schoolId);

        const classes = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
            ? response
            : [];

        setClassList(classes);
      } catch (error) {
        console.error(
          "Class API Error:",
          error
        );
      }
    };

    loadClasses();
  }, []);

  /* =====================================================
     DISPLAY CLASSES
  ===================================================== */

  const displayClasses = useMemo(() => {
    if (
      Array.isArray(classList) &&
      classList.length > 0
    ) {
      return classList;
    }

    return defaultClasses;
  }, [classList]);

  /* =====================================================
     CLASS HELPERS
  ===================================================== */

  const getClassId = (item) => {
    return (
      item?.id ??
      item?.classId ??
      item?.class_id
    );
  };

  const getClassName = (item) => {
    return (
      item?.className ||
      item?.classname ||
      item?.class_name ||
      item?.name ||
      `Class ${getClassId(item) || ""}`
    );
  };

  /* =====================================================
     CURRENT CLASS
  ===================================================== */

  const currentClass =
    displayClasses.find(
      (item) =>
        String(
          getClassId(item)
        ) ===
        String(
          currentClassId
        )
    );

  const currentClassName =
    currentClass
      ? getClassName(currentClass)
      : "Class 7";

  /* =====================================================
     TARGET CLASS
  ===================================================== */

  const selectedClass =
    displayClasses.find(
      (item) =>
        String(
          getClassId(item)
        ) ===
        String(
          selectedClassId
        )
    );

  const selectedClassName =
    selectedClass
      ? getClassName(selectedClass)
      : `Class ${selectedClassId}`;

  /* =====================================================
     CLASS CHANGE
  ===================================================== */

  const handleClassChange = async (
    value
  ) => {
    setSelectedClassId(value);

    // Reset dependent selections
    setSelectedCourseIds([]);
    setSelectedBatches([]);
    setSelectedPackageId("");
    setSelectedPlanId("");
    setSelectedAmount(24000);

    setCourseList([]);
    setCourseBatchList([]);
    setPlanList([]);
    setAcademicSession({ startDate: "", endDate: "" });

    if (!value) {
      return;
    }

    try {
      const storedUser = JSON.parse(
        localStorage.getItem("user") || "{}"
      );

      const schoolId =
        storedUser?.SchoolId ||
        storedUser?.schoolId ||
        storedUser?.SchoolID ||
        localStorage.getItem("schoolId");

      // Previous API:
      // const response = await getCoursesByclassId(value);
      const response =
        await getCoursesByTagAndSchoolId(
          value,
          schoolId
        );

      if (
        response?.success &&
        Array.isArray(response?.data)
      ) {
        setCourseList(
          response.data
        );

        const sessionDates = getAcademicSessionDates(response);
        if (sessionDates.startDate && sessionDates.endDate) {
          setAcademicSession(sessionDates);
        }
      }
    } catch (error) {
      console.error(
        "Course API Error:",
        error
      );
    }
  };

  /* =====================================================
     LOAD COURSES FOR CLASS 9 INITIALLY

     Since target class starts at Class 9,
     load Class 9 courses on page load.
  ===================================================== */

  useEffect(() => {
    const loadInitialCourses = async () => {
      try {
        const storedUser = JSON.parse(
          localStorage.getItem("user") || "{}"
        );

        const schoolId =
          storedUser?.SchoolId ||
          storedUser?.schoolId ||
          storedUser?.SchoolID ||
          localStorage.getItem("schoolId");

        // Previous API:
        // const response = await getCoursesByclassId(selectedClassId);
        const response =
          await getCoursesByTagAndSchoolId(
            selectedClassId,
            schoolId
          );

        if (
          response?.success &&
          Array.isArray(response?.data)
        ) {
          setCourseList(
            response.data
          );

          const sessionDates = getAcademicSessionDates(response);
          if (sessionDates.startDate && sessionDates.endDate) {
            setAcademicSession(sessionDates);
          }
        }
      } catch (error) {
        console.error(
          "Initial Course API Error:",
          error
        );
      }
    };

    if (selectedClassId) {
      loadInitialCourses();
    }
  }, []);

  /* =====================================================
     COURSE HELPERS
  ===================================================== */

  const getCourseId = (course) => {
    return (
      course?.courseId ??
      course?.id ??
      course?.course_id
    );
  };

  const getCourseName = (course) => {
    return (
      course?.courseName ||
      course?.course_name ||
      course?.name ||
      "Course"
    );
  };

  /* =====================================================
     COURSE SELECT
  ===================================================== */

  const toggleCourse = async (
    courseId
  ) => {
    const exists =
      selectedCourseIds.includes(
        courseId
      );

    const updatedIds = exists
      ? selectedCourseIds.filter(
        (id) => id !== courseId
      )
      : [
        ...selectedCourseIds,
        courseId,
      ];

    setSelectedCourseIds(
      updatedIds
    );

    setSelectedBatches([]);
    setSelectedPackageId("");
    setSelectedPlanId("");
    setSelectedAmount(24000);

    setCourseBatchList([]);

    if (
      !selectedClassId ||
      updatedIds.length === 0
    ) {
      return;
    }

    try {
      /*
       * SAME API
       */
      const storedUser = JSON.parse(
        localStorage.getItem("user") || "{}"
      );

      const schoolId =
        storedUser?.SchoolId ||
        storedUser?.schoolId ||
        storedUser?.SchoolID ||
        localStorage.getItem("schoolId") ||
        0;

      const response =
        await fetchBatch({
          classId:
            Number(
              selectedClassId
            ),
          courseIds:
            updatedIds,
          schoolId: Number(schoolId),
        });

      const batches = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response)
          ? response
          : [];

      setCourseBatchList(batches);

      const sessionDates = getAcademicSessionDates(response);
      if (sessionDates.startDate && sessionDates.endDate) {
        setAcademicSession(sessionDates);
      }
    } catch (error) {
      console.error(
        "Batch API Error:",
        error
      );
    }
  };

  /* =====================================================
     BATCH
  ===================================================== */

  const getBatchId = (batch) => (
    batch?.batchId ??
    batch?.id ??
    batch?.batch_id
  );

  const getBatchCourseId = (batch) => (
    batch?.courseId ??
    batch?.courseID ??
    batch?.course_id ??
    batch?.assignedCourseId ??
    batch?.assignedCourseID
  );

  const selectBatch = (
    courseId,
    batch
  ) => {
    setSelectedBatches((previousBatches) => [
      ...previousBatches.filter(
        (selectedBatch) =>
          Number(selectedBatch.courseId) !== Number(courseId)
      ),
      {
        ...batch,
        courseId: Number(courseId),
        batchId: Number(getBatchId(batch)),
      },
    ]);

    setSelectedPackageId(
      batch?.packageId ??
      batch?.packageID ??
      ""
    );

    setSelectedPlanId("");
    setSelectedAmount(24000);
  };

  /* =====================================================
     GET PLANS
     API UNCHANGED
  ===================================================== */

  useEffect(() => {
    const loadPlans = async () => {
      if (
        selectedCourseIds.length ===
        0
      ) {
        return;
      }

      try {
        const response =
          await getPlans({
            courseIds:
              selectedCourseIds,
          });

        if (
          response?.success &&
          Array.isArray(
            response?.plans
          )
        ) {
          setPlanList(
            response.plans
          );
        } else if (
          response?.success &&
          Array.isArray(
            response?.data
          )
        ) {
          setPlanList(
            response.data
          );
        }
      } catch (error) {
        console.error(
          "Plan API Error:",
          error
        );
      }
    };

    loadPlans();
  }, [selectedCourseIds]);

  /* =====================================================
     PLAN HELPERS
  ===================================================== */

  const getPlanId = (
    plan
  ) => {
    return (
      plan?.planId ??
      plan?.id ??
      plan?.plan_id
    );
  };

  const getPlanName = (
    plan
  ) => {
    return (
      plan?.planName ||
      plan?.name ||
      plan?.frequency ||
      plan?.plan ||
      "Plan"
    );
  };

  const getActualAmount = (
    plan
  ) => {
    return Number(
      plan?.actualPrice ??
      plan?.price ??
      plan?.baseAmount ??
      plan?.amount ??
      0
    );
  };

  const getFinalAmount = (
    plan
  ) => {
    return Number(
      plan?.finalAmount ??
      plan?.discountPrice ??
      plan?.netPrice ??
      plan?.payableAmount ??
      plan?.amount ??
      plan?.price ??
      0
    );
  };

  const getDiscountAmount = (
    plan
  ) => {
    const actual =
      getActualAmount(
        plan
      );

    const final =
      getFinalAmount(
        plan
      );

    if (
      actual > final &&
      final > 0
    ) {
      return (
        actual - final
      );
    }

    return 0;
  };

  const formatMoney = (
    value
  ) => {
    return Number(
      value || 0
    ).toLocaleString(
      "en-IN"
    );
  };

  /* =====================================================
     FALLBACK PAYMENT PLANS
  ===================================================== */

  const fallbackPlans = [
    {
      planId: "full",
      planName:
        "Full — one time",
      actualPrice: 28800,
      finalAmount: 24000,
    },
    {
      planId: "half",
      planName:
        "Half-yearly",
      actualPrice: 14400,
      finalAmount: 12000,
    },
    {
      planId: "quarter",
      planName:
        "Quarterly",
      actualPrice: 7200,
      finalAmount: 7200,
    },
    {
      planId: "monthly",
      planName:
        "Monthly*",
      actualPrice: 2400,
      finalAmount: 2400,
    },
  ];

  const displayPlans =
    planList.length > 0
      ? planList
      : fallbackPlans;

  /* =====================================================
     SELECT PAYMENT PLAN
  ===================================================== */

  const selectPlan = (
    plan
  ) => {
    const id =
      getPlanId(plan);

    const amount =
      getFinalAmount(plan);

    setSelectedPlanId(
      String(id)
    );

    setSelectedAmount(
      amount
    );
  };

  /* =====================================================
     PAYMENT METHODS
  ===================================================== */

  const paymentMethods = [
    "Debit or credit card",
    "Internet banking",
    "UPI",
    "GPay, Paytm or PhonePe",
  ];

  /* =====================================================
     PAY
     API FUNCTION SAME
  ===================================================== */

  const handlePay = () => {
    try {
      const user = JSON.parse(
        localStorage.getItem("user") || "{}"
      );

      // ==============================
      // REQUIRED VALIDATION
      // ==============================

      if (!user?.id && !user?.userId && !user?.uuid) {
        alert("User information is missing. Please login again.");
        return;
      }

      if (!selectedClassId) {
        alert("Please select class.");
        return;
      }

      if (!subscriptionType) {
        alert("Please select subscription type.");
        return;
      }

      if (!weekday) {
        alert("Please select weekday.");
        return;
      }

      if (
        !selectedCourseIds ||
        selectedCourseIds.length === 0
      ) {
        alert("Please select at least one subject.");
        return;
      }

      if (
        selectedBatches.length !== selectedCourseIds.length ||
        selectedCourseIds.some(
          (courseId) =>
            !selectedBatches.some(
              (batch) => Number(batch.courseId) === Number(courseId)
            )
        )
      ) {
        alert("Please select at least one batch for each course.");
        return;
      }

      if (!selectedPlanId) {
        alert("Please select payment plan.");
        return;
      }

      if (!paymentMethod) {
        alert("Please select payment method.");
        return;
      }

      if (
        !selectedAmount ||
        Number(selectedAmount) <= 0
      ) {
        alert("Please select a valid payment plan.");
        return;
      }

      // ==============================
      // SELECTED PLAN
      // ==============================

      const selectedPlan = displayPlans.find(
        (plan) =>
          String(getPlanId(plan)) ===
          String(selectedPlanId)
      );

      // ==============================
      // SELECTED SUBJECT NAMES
      // ==============================

      const selectedSubjectNames =
        selectedCourseIds.map((courseId) => {
          const course = courseList.find(
            (item) =>
              Number(getCourseId(item)) ===
              Number(courseId)
          );

          // If API course is available
          if (course) {
            return getCourseName(course);
          }

          // Fallback for your current subjects
          if (Number(courseId) === 1) {
            return "Mathematics";
          }

          if (Number(courseId) === 2) {
            return "Science";
          }

          return `Subject ${courseId}`;
        });

      // ==============================
      // DATA FOR RECONFIRMATION PAGE
      // ==============================

      const confirmationData = {
        userId:
          user?.uuid ??
          user?.id ??
          user?.userId,

        schoolId:
          user?.SchoolId ??
          user?.schoolId ??
          user?.SchoolID ??
          localStorage.getItem("schoolId"),

        // Current class
        currentClassId:
          Number(currentClassId),

        currentClassName:
          currentClassName,

        currentAcademicExpired:
          currentAcademicExpired,

        // Selected class
        selectedClassId:
          Number(selectedClassId),

        selectedClassName:
          selectedClassName,

        // Subscription
        subscriptionType:
          subscriptionType,

        // Weekdays
        weekday:
          weekday,

        // Subjects IDs
        selectedCourseIds:
          selectedCourseIds,

        // Subjects names
        subjects:
          selectedSubjectNames,

        // Batch
        selectedBatches:
          selectedBatches,

        // Package
        packageId:
          selectedPackageId,

        // Plan
        planId:
          selectedPlanId,

        planName:
          selectedPlan
            ? getPlanName(selectedPlan)
            : "",

        // Amount
        amount:
          Number(selectedAmount),

        // Payment
        paymentMethod:
          paymentMethod,

        // Session
        startDate:
          academicSession.startDate,

        endDate:
          academicSession.endDate,

        academicSession:
          academicSessionText,
      };

      console.log(
        "================================"
      );

      console.log(
        "DATA GOING TO RECONFIRMATION:",
        confirmationData
      );

      console.log(
        "SELECTED SUBJECT IDS:",
        selectedCourseIds
      );

      console.log(
        "SELECTED SUBJECT NAMES:",
        selectedSubjectNames
      );

      console.log(
        "================================"
      );

      // ==============================
      // GO TO EXISTING RECONFIRMATION
      // ==============================

      navigate("/reconfirmation", {
        state: confirmationData,
      });

    } catch (error) {
      console.error(
        "Reconfirmation navigation error:",
        error
      );

      alert(
        "Something went wrong. Please try again."
      );
    }
  };
  /* =====================================================
     UI
  ===================================================== */

  return (
    <div
      className="
        min-h-screen
        w-full
        bg-[#f7f3ea]
        text-[#17144b]
      "
    >

      <div
        className="
          w-full
          max-w-[1280px]
          mx-auto
          px-4
          sm:px-6
          lg:px-8
          py-5
        "
      >

        {/* =================================================
            HEADER
        ================================================= */}

        <header
          className="
            w-full
            min-h-[48px]
            bg-[#4036cc]
            rounded-[9px]
            px-4
            sm:px-5
            flex
            items-center
            justify-between
            mb-4
          "
        >

          <h1
            className="
              text-white
              text-sm
              sm:text-[15px]
              font-bold
            "
          >
            Buy | Renew subscription
          </h1>

          <div
            className="
              flex
              items-center
              gap-5
              text-white
            "
          >

            <span
              className="text-xs"
            >
              ♧
            </span>

            <button
              type="button"
              onClick={() =>
                navigate(-1)
              }
              className="
                text-lg
                leading-none
                hover:opacity-80
              "
            >
              ←
            </button>

          </div>

        </header>


        {/* =================================================
            MAIN
        ================================================= */}

        <div
          className="
            grid
            grid-cols-1
            lg:grid-cols-[300px_minmax(0,1fr)]
            gap-4
            items-start
          "
        >

          {/* =================================================
              LEFT SIDE
          ================================================= */}

          <aside
            className="
              w-full
              space-y-4
            "
          >

            {/* PER SUBJECT */}

            <div
              className="
                bg-[#4036cc]
                rounded-[10px]
                px-4
                py-5
                text-white
                min-h-[100px]
                flex
                flex-col
                justify-center
              "
            >

              <p
                className="
                  uppercase
                  tracking-[0.14em]
                  text-[8px]
                  text-white/75
                  mb-1
                "
              >
                Per subject
              </p>

              <div
                className="
                  flex
                  items-baseline
                  gap-1
                  flex-wrap
                "
              >

                <span
                  className="
                    text-[24px]
                    sm:text-[26px]
                    font-bold
                    leading-none
                  "
                >
                  ₹1,200
                </span>

                <span
                  className="
                    text-[10px]
                    sm:text-[11px]
                  "
                >
                  / subject / month
                </span>

              </div>

            </div>


            {/* FEE */}

            <div
              className="
                bg-white
                border
                border-[#e2d9c8]
                rounded-[10px]
                px-4
                py-4
                min-h-[100px]
              "
            >

              <p
                className="
                  uppercase
                  tracking-[0.14em]
                  text-[8px]
                  text-[#8b84a3]
                  mb-2
                "
              >
                Fee for classes 6, 7, 8, 9, 10
              </p>

              <p
                className="
                  text-[#4036cc]
                  text-[17px]
                  font-bold
                "
              >
                ₹24,000 per year*
              </p>

              <p
                className="
                  text-[9px]
                  text-[#8b84a3]
                  mt-1
                "
              >
                Mathematics and Science
              </p>

            </div>


            {/* INCLUDED */}

            <div
              className="
                bg-white
                border
                border-[#e2d9c8]
                rounded-[10px]
                px-4
                py-5
              "
            >

              <p
                className="
                  uppercase
                  tracking-[0.14em]
                  text-[8px]
                  text-[#8b84a3]
                  mb-3
                "
              >
                What's included
              </p>

              <div
                className="
                  space-y-2.5
                  text-[9px]
                  sm:text-[10px]
                  leading-relaxed
                  text-[#403b5b]
                "
              >

                <p>
                  ✓ 3 live classes a week,
                  2 hours a day
                </p>

                <p>
                  ✓ Every class recorded
                  for revision
                </p>

                <p>
                  ✓ 4 tests per topic plus
                  clone re-tests
                </p>

                <p>
                  ✓ Stepwise guided solutions
                </p>

                <p>
                  ✓ Class notes and curated
                  videos
                </p>

                <p>
                  ✓ Monthly progress reports
                  for parents
                </p>

              </div>

            </div>


            <p
              className="
                text-[8px]
                leading-relaxed
                text-[#8b84a3]
                px-1
              "
            >
              *On the full one-time payment
              plan, with two months' discount
              applied. Other plans are charged
              at ₹2,400 per month for both
              subjects.
            </p>

          </aside>


          {/* =================================================
              RIGHT SIDE
          ================================================= */}

          <section
            className="
              bg-white
              border
              border-[#e2d9c8]
              rounded-[10px]
              px-4
              sm:px-5
              py-5
              w-full
              min-w-0
            "
          >

            {/* =================================================
                CURRENT CLASS / EXPIRED STATUS
            ================================================= */}

            <div
              className="
                flex
                flex-wrap
                items-center
                justify-between
                gap-3
                mb-5
              "
            >

              <div>

                <h2
                  className="
                    text-[13px]
                    sm:text-[14px]
                    font-bold
                    text-[#17144b]
                  "
                >
                  Hi, you are subscribing
                  to InstaED.
                </h2>

                <p
                  className="
                    text-[8px]
                    text-[#8b84a3]
                    mt-1
                  "
                >
                  Current class:{" "}
                  <span
                    className="
                      font-semibold
                      text-[#4036cc]
                    "
                  >
                    {currentClassName}
                  </span>

                  {" · "}

                  <span
                    className="
                      text-[#c44b35]
                      font-semibold
                    "
                  >
                    Academic session expired
                  </span>
                </p>

              </div>


              <div
                className="
                  flex
                  items-center
                  gap-2
                "
              >

                <span
                  className="
                    border
                    border-[#e2d9c8]
                    rounded-full
                    px-3
                    py-1.5
                    text-[8px]
                    text-[#6f6887]
                    whitespace-nowrap
                  "
                >
                  Current:{" "}
                  {currentClassName}
                </span>

              </div>

            </div>


            {/* =================================================
                SESSION + TARGET CLASS
            ================================================= */}

            <div
              className="
                grid
                grid-cols-1
                md:grid-cols-2
                gap-3
                mb-4
              "
            >

              <div>

                <label
                  className="
                    block
                    text-[9px]
                    text-[#6f6887]
                    mb-1.5
                  "
                >
                  Academic session
                </label>

                <div className="grid grid-cols-2 gap-2 mb-2">
                  <div>
                    <label className="block text-[8px] text-[#6f6887] mb-1">
                      Start from
                    </label>
                    <input
                      type="date"
                      value={academicSession.startDate
                        ? String(academicSession.startDate).slice(0, 10)
                        : ""}
                      onChange={(e) =>
                        setAcademicSession((previous) => ({
                          ...previous,
                          startDate: e.target.value,
                        }))
                      }
                      className="w-full h-[36px] border border-[#ddd4c2] rounded-[7px] px-2 text-[10px] bg-white"
                    />
                  </div>

                  <div>
                    <label className="block text-[8px] text-[#6f6887] mb-1">
                      End to
                    </label>
                    <input
                      type="date"
                      value={academicSession.endDate
                        ? String(academicSession.endDate).slice(0, 10)
                        : ""}
                      onChange={(e) =>
                        setAcademicSession((previous) => ({
                          ...previous,
                          endDate: e.target.value,
                        }))
                      }
                      className="w-full h-[36px] border border-[#ddd4c2] rounded-[7px] px-2 text-[10px] bg-white"
                    />
                  </div>
                </div>

                <div className="hidden">
              

                  <span>
                    ⌄
                  </span>

                </div>

              </div>


              <div>

                <label
                  className="
                    block
                    text-[9px]
                    text-[#6f6887]
                    mb-1.5
                  "
                >
                  Class you're subscribing or renewing to
                </label>

                <select
                  value={
                    selectedClassId
                  }
                  onChange={(e) =>
                    handleClassChange(
                      e.target.value
                    )
                  }
                  className="
                    w-full
                    h-[36px]
                    border
                    border-[#4036cc]
                    rounded-[7px]
                    px-3
                    text-[10px]
                    bg-white
                    outline-none
                    focus:ring-1
                    focus:ring-[#4036cc]
                    cursor-pointer
                  "
                >

                  <option value="">
                    Select Class
                  </option>

                  {displayClasses.map(
                    (item) => {

                      const id =
                        getClassId(
                          item
                        );

                      return (
                        <option
                          key={id}
                          value={id}
                        >
                          {getClassName(
                            item
                          )}
                        </option>
                      );
                    }
                  )}

                </select>

              </div>

            </div>


            {/* =================================================
                SUBSCRIPTION TYPE
            ================================================= */}

            <div
              className="mb-4"
            >

              <p
                className="
                  text-[9px]
                  text-[#6f6887]
                  mb-1.5
                "
              >
                Subscription type
              </p>

              <div
                className="
                  grid
                  grid-cols-1
                  sm:grid-cols-2
                  gap-2
                "
              >

                {[
                  "Renewal",
                  "New",
                ].map(
                  (type) => {

                    const selected =
                      subscriptionType ===
                      type;

                    return (
                      <button
                        key={type}
                        type="button"
                        onClick={() =>
                          setSubscriptionType(
                            type
                          )
                        }
                        className={`
                          h-[40px]
                          rounded-[7px]
                          border
                          flex
                          items-center
                          gap-2.5
                          px-3
                          text-[10px]
                          text-left
                          transition
                          ${selected
                            ? "border-[#4036cc] bg-[#f0edff]"
                            : "border-[#ddd4c2] bg-white"
                          }
                        `}
                      >

                        <span
                          className={`
                            w-[16px]
                            h-[16px]
                            rounded-full
                            flex
                            items-center
                            justify-center
                            text-[9px]
                            shrink-0
                            ${selected
                              ? "bg-[#4036cc] text-white"
                              : "border border-[#d8cfbd]"
                            }
                          `}
                        >
                          {selected &&
                            "✓"}
                        </span>

                        {type}

                      </button>
                    );
                  }
                )}

              </div>

            </div>


            {/* =================================================
                WEEKDAY
            ================================================= */}

            <div
              className="mb-4"
            >

              <p
                className="
                  text-[9px]
                  text-[#6f6887]
                  mb-1.5
                "
              >
                Select weekdays
              </p>

              <div
                className="
                  grid
                  grid-cols-1
                  sm:grid-cols-2
                  gap-2
                "
              >

                {[
                  "Mon · Wed · Fri",
                  "Tue · Thu · Sat",
                ].map(
                  (day) => {

                    const selected =
                      weekday === day;

                    return (
                      <button
                        key={day}
                        type="button"
                        onClick={() =>
                          setWeekday(
                            day
                          )
                        }
                        className={`
                          h-[40px]
                          rounded-[7px]
                          border
                          flex
                          items-center
                          gap-2.5
                          px-3
                          text-[10px]
                          text-left
                          transition
                          ${selected
                            ? "border-[#4036cc] bg-[#f0edff]"
                            : "border-[#ddd4c2] bg-white"
                          }
                        `}
                      >

                        <span
                          className={`
                            w-[16px]
                            h-[16px]
                            rounded-full
                            flex
                            items-center
                            justify-center
                            text-[9px]
                            shrink-0
                            ${selected
                              ? "bg-[#4036cc] text-white"
                              : "border border-[#d8cfbd]"
                            }
                          `}
                        >
                          {selected &&
                            "✓"}
                        </span>

                        {day}

                      </button>
                    );
                  }
                )}

              </div>

            </div>


            {/* =================================================
                SUBJECTS
            ================================================= */}

            <div
              className="mb-4"
            >

              <p
                className="
                  text-[9px]
                  text-[#6f6887]
                  mb-1.5
                "
              >
                Select subjects
              </p>

              <div
                className="
                  grid
                  grid-cols-1
                  sm:grid-cols-2
                  gap-2
                "
              >

                {courseList.length >
                  0 ? (
                  courseList.map(
                    (
                      course
                    ) => {

                      const id =
                        getCourseId(
                          course
                        );

                      const selected =
                        selectedCourseIds.includes(
                          id
                        );

                      return (
                        <button
                          key={id}
                          type="button"
                          onClick={() =>
                            toggleCourse(
                              id
                            )
                          }
                          className={`
                            h-[40px]
                            rounded-[7px]
                            border
                            flex
                            items-center
                            gap-2.5
                            px-3
                            text-[10px]
                            text-left
                            ${selected
                              ? "border-[#4036cc] bg-[#f0edff]"
                              : "border-[#ddd4c2] bg-white"
                            }
                          `}
                        >

                          <span
                            className={`
                              w-[16px]
                              h-[16px]
                              rounded-[4px]
                              flex
                              items-center
                              justify-center
                              text-[9px]
                              shrink-0
                              ${selected
                                ? "bg-[#4036cc] text-white"
                                : "border border-[#d8cfbd]"
                              }
                            `}
                          >
                            {selected &&
                              "✓"}
                          </span>

                          {getCourseName(
                            course
                          )}

                        </button>
                      );
                    }
                  )
                ) : (
                  <>
                    {/* Mathematics */}

                    <button
                      type="button"
                      onClick={() =>
                        toggleCourse(
                          1
                        )
                      }
                      className={`
                        h-[40px]
                        rounded-[7px]
                        border
                        flex
                        items-center
                        gap-2.5
                        px-3
                        text-[10px]
                        text-left
                        ${selectedCourseIds.includes(
                        1
                      )
                          ? "border-[#4036cc] bg-[#f0edff]"
                          : "border-[#ddd4c2] bg-white"
                        }
                      `}
                    >

                      <span
                        className={`
                          w-[16px]
                          h-[16px]
                          rounded-[4px]
                          flex
                          items-center
                          justify-center
                          text-[9px]
                          ${selectedCourseIds.includes(
                          1
                        )
                            ? "bg-[#4036cc] text-white"
                            : "border border-[#d8cfbd]"
                          }
                        `}
                      >
                        {selectedCourseIds.includes(
                          1
                        ) && "✓"}
                      </span>

                      {/* Mathematics */}

                    </button>


                    {/* Science */}

                    <button
                      type="button"
                      onClick={() =>
                        toggleCourse(
                          2
                        )
                      }
                      className={`
                        h-[40px]
                        rounded-[7px]
                        border
                        flex
                        items-center
                        gap-2.5
                        px-3
                        text-[10px]
                        text-left
                        ${selectedCourseIds.includes(
                        2
                      )
                          ? "border-[#4036cc] bg-[#f0edff]"
                          : "border-[#ddd4c2] bg-white"
                        }
                      `}
                    >

                      <span
                        className={`
                          w-[16px]
                          h-[16px]
                          rounded-[4px]
                          flex
                          items-center
                          justify-center
                          text-[9px]
                          ${selectedCourseIds.includes(
                          2
                        )
                            ? "bg-[#4036cc] text-white"
                            : "border border-[#d8cfbd]"
                          }
                        `}
                      >
                        {selectedCourseIds.includes(
                          2
                        ) && "✓"}
                      </span>

                      {/* Science */}

                    </button>
                  </>
                )}

              </div>

            </div>


            {/* =================================================
                BATCHES
            ================================================= */}

            {courseBatchList.length > 0 && (
              <div className="mb-4">
                <label className="block text-[9px] text-[#6f6887] mb-1.5">
                  Select batch
                </label>

                {selectedCourseIds.map((courseId) => {
                  const course = courseList.find(
                    (item) => Number(getCourseId(item)) === Number(courseId)
                  );
                  const courseBatches = courseBatchList.filter(
                    (batch) => Number(getBatchCourseId(batch)) === Number(courseId)
                  );
                  const selectedBatch = selectedBatches.find(
                    (batch) => Number(batch.courseId) === Number(courseId)
                  );

                  return (
                    <div key={courseId} className="mb-2">
                      <label className="block text-[10px] font-medium text-[#4036cc] mb-1">
                        {course ? getCourseName(course) : `Course ${courseId}`}
                      </label>
                      <select
                        value={selectedBatch?.batchId || ""}
                        onChange={(e) => {
                          const batch = courseBatches.find(
                            (item) => String(getBatchId(item)) === e.target.value
                          );

                          if (batch) {
                            selectBatch(courseId, batch);
                          }
                        }}
                        className="w-full h-[36px] border border-[#4036cc] rounded-[7px] px-3 text-[10px] bg-white outline-none focus:ring-1 focus:ring-[#4036cc] cursor-pointer"
                      >
                        <option value="">Select Batch</option>
                        {courseBatches.map((batch) => {
                          const batchId = getBatchId(batch);
                          const batchName =
                            batch.batchName ??
                            batch.name ??
                            batch.batchtype ??
                            `Batch ${batchId}`;

                          return (
                            <option key={batchId} value={batchId}>
                              {batchName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  );
                })}
              </div>
            )}


            {/* =================================================
                PAYMENT PLAN
            ================================================= */}

            <div
              className="mb-4"
            >

              <p
                className="
                  uppercase
                  tracking-[0.12em]
                  text-[9px]
                  text-[#6f6887]
                  mb-1.5
                "
              >
                Select the payment plan
              </p>

              {/* Desktop */}

              <div
                className="
                  hidden
                  sm:block
                  overflow-hidden
                  border
                  border-[#ddd4c2]
                  rounded-[7px]
                "
              >

                <div
                  className="
                    grid
                    grid-cols-[1.5fr_1fr_1fr_1fr]
                    bg-[#4036cc]
                    text-white
                    px-3
                    h-[25px]
                    items-center
                    text-[8px]
                    uppercase
                    font-bold
                  "
                >
                  <span>
                    Frequency
                  </span>

                  <span>
                    Price
                  </span>

                  <span>
                    Discount
                  </span>

                  <span>
                    Net price
                  </span>
                </div>


                {displayPlans.map(
                  (plan) => {

                    const id =
                      getPlanId(
                        plan
                      );

                    const selected =
                      String(
                        selectedPlanId
                      ) ===
                      String(id);

                    const actual =
                      getActualAmount(
                        plan
                      );

                    const final =
                      getFinalAmount(
                        plan
                      );

                    const discount =
                      getDiscountAmount(
                        plan
                      );

                    return (
                      <button
                        key={id}
                        type="button"
                        onClick={() =>
                          selectPlan(
                            plan
                          )
                        }
                        className={`
                          w-full
                          grid
                          grid-cols-[1.5fr_1fr_1fr_1fr]
                          min-h-[36px]
                          px-3
                          items-center
                          text-left
                          border-t
                          border-[#e5ddce]
                          text-[9px]
                          transition
                          ${selected
                            ? "bg-[#f0edff]"
                            : "bg-white hover:bg-[#faf8f3]"
                          }
                        `}
                      >

                        <span
                          className="
                            flex
                            items-center
                            gap-2
                          "
                        >

                          <span
                            className={`
                              w-[7px]
                              h-[7px]
                              rounded-full
                              shrink-0
                              ${selected
                                ? "bg-[#14865a]"
                                : "bg-[#ddd4c2]"
                              }
                            `}
                          />

                          <span
                            className={
                              selected
                                ? "font-bold"
                                : ""
                            }
                          >
                            {getPlanName(
                              plan
                            )}
                          </span>

                        </span>

                        <span>
                          ₹
                          {formatMoney(
                            actual
                          )}
                        </span>

                        <span
                          className="text-[#14865a]"
                        >
                          {discount >
                            0
                            ? `-₹${formatMoney(
                              discount
                            )}`
                            : "—"}
                        </span>

                        <span
                          className="
                            font-bold
                          "
                        >
                          ₹
                          {formatMoney(
                            final
                          )}
                        </span>

                      </button>
                    );
                  }
                )}

              </div>


              {/* Mobile */}

              <div
                className="
                  sm:hidden
                  space-y-2
                "
              >

                {displayPlans.map(
                  (plan) => {

                    const id =
                      getPlanId(
                        plan
                      );

                    const selected =
                      String(
                        selectedPlanId
                      ) ===
                      String(id);

                    const actual =
                      getActualAmount(
                        plan
                      );

                    const final =
                      getFinalAmount(
                        plan
                      );

                    const discount =
                      getDiscountAmount(
                        plan
                      );

                    return (
                      <button
                        key={id}
                        type="button"
                        onClick={() =>
                          selectPlan(
                            plan
                          )
                        }
                        className={`
                          w-full
                          rounded-[7px]
                          border
                          p-3
                          text-left
                          ${selected
                            ? "border-[#4036cc] bg-[#f0edff]"
                            : "border-[#ddd4c2] bg-white"
                          }
                        `}
                      >

                        <div
                          className="
                            flex
                            items-center
                            justify-between
                          "
                        >

                          <span
                            className="
                              text-[10px]
                              font-semibold
                            "
                          >
                            {getPlanName(
                              plan
                            )}
                          </span>

                          <span
                            className="
                              text-[10px]
                              font-bold
                            "
                          >
                            ₹
                            {formatMoney(
                              final
                            )}
                          </span>

                        </div>

                        <div
                          className="
                            flex
                            gap-4
                            mt-2
                            text-[8px]
                            text-[#8b84a3]
                          "
                        >

                          <span>
                            Price ₹
                            {formatMoney(
                              actual
                            )}
                          </span>

                          <span
                            className="
                              text-[#14865a]
                            "
                          >
                            Discount{" "}
                            {discount >
                              0
                              ? `₹${formatMoney(
                                discount
                              )}`
                              : "—"}
                          </span>

                        </div>

                      </button>
                    );
                  }
                )}

              </div>


              <p
                className="
                  text-[8px]
                  text-[#8b84a3]
                  mt-1.5
                "
              >
                *Monthly is available only
                with auto-renew switched on.
              </p>

            </div>


            {/* =================================================
                PAYMENT METHOD
            ================================================= */}

            <div
              className="mb-4"
            >

              <p
                className="
                  uppercase
                  tracking-[0.12em]
                  text-[9px]
                  text-[#6f6887]
                  mb-1.5
                "
              >
                How do you wish to pay?
              </p>

              <div
                className="
                  grid
                  grid-cols-1
                  sm:grid-cols-2
                  lg:grid-cols-4
                  gap-2
                "
              >

                {paymentMethods.map(
                  (method) => {

                    const selected =
                      paymentMethod ===
                      method;

                    return (
                      <button
                        key={method}
                        type="button"
                        onClick={() =>
                          setPaymentMethod(
                            method
                          )
                        }
                        className={`
                          min-h-[48px]
                          rounded-[7px]
                          border
                          px-3
                          flex
                          items-center
                          gap-2.5
                          text-left
                          text-[9px]
                          ${selected
                            ? "border-[#4036cc] bg-[#f0edff]"
                            : "border-[#ddd4c2] bg-white"
                          }
                        `}
                      >

                        <span
                          className={`
                            w-[16px]
                            h-[16px]
                            rounded-full
                            shrink-0
                            flex
                            items-center
                            justify-center
                            text-[9px]
                            ${selected
                              ? "bg-[#4036cc] text-white"
                              : "border border-[#d8cfbd]"
                            }
                          `}
                        >
                          {selected &&
                            "✓"}
                        </span>

                        {method}

                      </button>
                    );
                  }
                )}

              </div>

            </div>


            {/* =================================================
                PAY
            ================================================= */}

            <div
              className="
                flex
                items-center
                gap-3
                flex-wrap
              "
            >

              <button
                type="button"
                onClick={
                  handlePay
                }
                className="
                  bg-[#1d194e]
                  hover:bg-[#15123d]
                  text-white
                  rounded-full
                  px-5
                  h-[34px]
                  text-[10px]
                  font-bold
                  transition
                "
              >
                Pay ₹
                {formatMoney(
                  selectedAmount
                )}
              </button>

              <button
                type="button"
                onClick={() =>
                  navigate(
                    "/refund-policy"
                  )
                }
                className="
                  text-[#4036cc]
                  text-[9px]
                  hover:underline
                "
              >
                Refund policy
              </button>

            </div>

          </section>

        </div>


        {/* =================================================
            FOOTER
        ================================================= */}

        <footer
          className="
            border-t
            border-[#e3dccd]
            mt-10
            pt-5
            pb-3
            flex
            justify-center
            items-center
            gap-5
            text-[8px]
            text-[#8b84a3]
          "
        >

          <button
            type="button"
            onClick={() =>
              navigate(
                "/terms-condition"
              )
            }
            className="
              hover:text-[#4036cc]
            "
          >
            Terms of use
          </button>

          <button
            type="button"
            onClick={() =>
              navigate(
                "/policy"
              )
            }
            className="
              hover:text-[#4036cc]
            "
          >
            Privacy policy
          </button>

          <span>
            © 2026
          </span>

        </footer>

      </div>

    </div>
  );
};

export default SubscriptionPage;
